import { render, staticRenderFns } from "./ClubEdit.vue?vue&type=template&id=512b3161"
import script from "./ClubEdit.vue?vue&type=script&lang=js"
export * from "./ClubEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports